function OfferBar() {
  return (
    <div className="group mx-auto mt-10 flex max-w-4xl flex-wrap items-center justify-between gap-3 rounded-full border border-violet-200/50 bg-[#E1D1FB]/50 px-5 py-3 backdrop-blur-sm transition-all duration-300 hover:rounded-2xl hover:border-violet-200/70 hover:bg-[#E1D1FB] hover:shadow-[0_10px_30px_rgba(147,105,204,0.18)] sm:mt-12 sm:gap-4 sm:px-8 sm:py-3.5">
      <p className="flex flex-wrap items-center justify-center gap-2 text-base text-[#1B1B1B] sm:text-lg lg:text-xl xl:text-[24px]">
        <span className="text-lg" aria-hidden>
          🎉
        </span>
        <span>
          Limited Time Offer :{' '}
          <strong className="font-semibold text-[#1B1B1B]">Get Full Access at ₹99</strong>
        </span>
      </p>
      <button
        type="button"
        className="flex shrink-0 items-center gap-2 rounded-full bg-gradient-to-r from-[#6A74E1] to-[#B539FD] px-5 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-300 group-hover:shadow-md group-hover:brightness-105 sm:gap-3 sm:px-6 sm:py-2.5 sm:text-base"
      >
        Unlock Now
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="white" />
        </svg>
      </button>
    </div>
  );
}

export default OfferBar;
